"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashQueryStringUtils = exports.NoHashQueryStringUtils = void 0;
const appauth_1 = require("@openid/appauth");
class NoHashQueryStringUtils extends appauth_1.BasicQueryStringUtils {
    parse(input, useHash) {
        const output = super.parse(input, false /* never use hash */);
        return output;
    }
}
exports.NoHashQueryStringUtils = NoHashQueryStringUtils;
const keys = ["code", "session_state", "state"];
class HashQueryStringUtils extends appauth_1.BasicQueryStringUtils {
    parse(input, useHash) {
        const output = super.parse(input, true /* use hash */);
        // Fix AppAuthJs behavior
        let propertyToDelelete = null;
        Object.entries(output).map(([key, value]) => {
            keys.forEach(k => {
                if (key.endsWith(`?${k}`)) {
                    output[k] = value;
                    propertyToDelelete = key;
                }
            });
        });
        if (propertyToDelelete) {
            delete output[propertyToDelelete];
        }
        return output;
    }
}
exports.HashQueryStringUtils = HashQueryStringUtils;
//# sourceMappingURL=noHashQueryStringUtils.js.map